import { Skeleton, SkeletonProps } from '@chakra-ui/react';

export const ListSkeleton = ({ children, ...props }: SkeletonProps) => {
  return (
    <Skeleton startColor="blackAlpha.50" endColor="blackAlpha.100" {...props}>
      {children}
    </Skeleton>
  );
};
